"use client";
// import React from 'react';
// import { ResumeData } from '@/lib/schema';
// import { MdLink, MdOutlineLocationOn, MdOutlineMailOutline, MdPhone} from 'react-icons/md';
// import { FaLinkedin } from "react-icons/fa";

// // Helper function to handle both old and new language formats
// const getLanguageName = (lang: string | { name: string }): string => {
//   return typeof lang === 'string' ? lang : lang.name;
// };

// const Professional: React.FC<{ data: ResumeData }> = ({ data }) => {
//   const basics = data.basics;
//   const experience = data.experience || [];
//   const education = data.education || [];
//   const skills = data.skills || [];
//   const languages = basics.languages || [];
//   const interests = [];
//   const courses = [];
//   // Social links
//   const linkedin = basics.social?.find(s => s.label.toLowerCase().includes('linkedin'))?.url || '';

//   return (
//     <div className="flex bg-gray-100 min-h-screen font-serif print-two-column">
//       {/* Sidebar */}
//       <aside className="w-1/3 bg-[#2d3e50] text-white p-4 flex flex-col gap-8 min-h-screen print-section">
//         {/* Contact */}
//         <div className="space-y-4 print-compact">
//           {basics.email && <div className="flex items-center gap-2 wrap-anywhere"><MdOutlineMailOutline className="text-lg" />{basics.email}</div>}
//           {basics.phone && <div className="flex items-center gap-2"><MdPhone className="text-lg" />{basics.phone}</div>}
//           {basics.location && <div className="flex items-center gap-2"><MdOutlineLocationOn className="text-lg"></MdOutlineLocationOn>{basics.location}</div>}
//           {basics.social?.map((link) => {
//             const icon = link.label.toLowerCase().includes('linkedin') ? <FaLinkedin   className="text-xl" /> : <MdLink className="text-xl" />;
//             return <div key={link.label} className="flex items-center gap-2 wrap-anywhere text-sm">{icon}{link.url}</div>
//           })}
//         </div>
//         {/* Skills */}
//         <div>
//           <h2 className="uppercase font-bold text-lg mb-2 tracking-wider">Skills</h2>
//           <div className="flex flex-wrap gap-2">
//             {skills.map((skill) => (
//               <span key={skill} className="bg-[#3e5066] rounded px-3 py-1 text-sm whitespace-nowrap wrap-anywhere">{skill}</span>
//             ))}
//           </div>
//         </div>
//         {/* Languages */}
//       {languages.length > 0 && <div>
//           <h2 className="uppercase font-bold text-lg mb-2 tracking-wider">Languages</h2>
//           <ul className="space-y-1">
//             {languages
//               .map((lang) => getLanguageName(lang as string | { name: string }))
//               .map((langName, idx) => (
//                 <li key={idx}>
//                   <span className="font-semibold">{langName}</span>
//                 </li>
//               ))}
//           </ul>
//         </div>}

//         {/* Strengths Section - Only show if data exists */}
//         {basics.strengths && basics.strengths.length > 0 && (
//           <div>
//             <h2 className="uppercase font-bold text-lg mb-2 tracking-wider">Strengths</h2>
//             <div className="space-y-2">
//               {basics.strengths.map((strength, idx) => (
//                 <div key={idx}>
//                   <span className="font-semibold text-sm">{strength.title}</span>
//                   {strength.description && (
//                     <p className="text-xs text-gray-300 mt-1">{strength.description}</p>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Key Achievements Section - Only show if data exists */}
//         {basics.achievements && basics.achievements.length > 0 && (
//           <div>
//             <h2 className="uppercase font-bold text-lg mb-2 tracking-wider">Key Achievements</h2>
//             <div className="space-y-2">
//               {basics.achievements.map((achievement, idx) => (
//                 <div key={idx}>
//                   <span className="font-semibold text-sm">{achievement.title}</span>
//                   {achievement.description && (
//                     <p className="text-xs text-gray-300 mt-1">{achievement.description}</p>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//         {/* Hobbies & Interests */}
//         {basics.hobbies && basics.hobbies.length > 0 && (
//           <div>
//             <h2 className="uppercase font-bold text-lg mb-2 tracking-wider">Hobbies & Interests</h2>
//             <div className="flex flex-wrap gap-2">
//               {basics.hobbies.map((hobby, idx) => (
//                 <span key={idx} className="bg-[#3e5066] rounded px-3 py-1 text-sm whitespace-nowrap">{hobby}</span>
//               ))}
//             </div>
//           </div>
//         )}
//         {/* Interests (not in ResumeData, so skip rendering unless you want to add custom logic) */}
//       </aside>
//       {/* Main Content */}
//       <main className="flex-1 bg-white p-12 print-section">
//         {/* Header */}
//         <div className="border-b pb-4 mb-6 border-gray-700 print-compact">
//           <h1 className="text-4xl font-bold text-gray-800">{basics.name}</h1>
//           {basics.title && <h2 className="text-xl text-blue-600 font-semibold mb-2">{basics.title}</h2>}
//           {basics.summary && <p className="text-gray-700 text-base max-w-2xl">{basics.summary}</p>}
//         </div>
//         {/* Work Experience */}
//         <section className="mb-8 print-section">
//           <h2 className="flex items-center gap-2 text-2xl font-bold uppercase mb-4 text-gray-800">Experience</h2>
//           {experience.map((exp, idx) => (
//             <div key={idx} className="mb-6 print-compact">
//               <div className="flex justify-between items-center">
//                 <div>
//                   <span className="font-bold text-lg text-gray-700">{exp.role}</span>
//                   <span className="block text-gray-700 font-medium">{exp.company}</span>
//                 </div>
//                 <div className="text-right">
//                   <span className="block text-sm text-gray-500">{exp.startDate} - {exp.current ? 'Present' : exp.endDate}</span>
//                 </div>
//               </div>
//               {exp.summary && (
//                 <ul className="list-disc ml-6 mt-2 text-gray-700 text-sm">
//                   <li>{exp.summary}</li>
//                 </ul>
//               )}
//             </div>
//           ))}
//         </section>
//         {/* Courses (not in ResumeData, so skip rendering unless you want to add custom logic) */}
//         {/* Education */}
//         <section className="print-section">
//           <h2 className="flex items-center gap-2 text-2xl font-bold uppercase mb-4 text-gray-800">Education</h2>
//           <ul className="list-disc ml-6 text-gray-700 text-sm">
//             {education.map((edu, idx) => (
//               <li key={idx}>
//                 <span className="font-semibold">{edu.degree}</span>
//                 <span className="block text-xs text-gray-500 italic">{edu.institution}</span>
//                 <span className="block text-xs text-gray-500">{edu.startDate} - {edu.endDate}</span>
//               </li>
//             ))}
//           </ul>
//         </section>
//       </main>
//     </div>
//   );
// };

// export default Professional;


import React from "react";
import { ResumeData } from "@/lib/schema";
import { MdLink, MdOutlineLocationOn, MdOutlineMailOutline, MdPhone } from "react-icons/md";
import { FaLinkedin } from "react-icons/fa";

type Language = string | { name: string };

const getLanguageName = (lang: Language): string =>
  typeof lang === "string" ? lang : lang.name;

// Styles as objects
const sidebarStyle: React.CSSProperties = {
  width: "32%",
  background: "#2d3e50",
  color: "#fff",
  padding: "28px 22px",
  minHeight: "100vh",
  fontFamily: "serif",
  display: "flex",
  flexDirection: "column",
  gap: "34px",
  margin:0,
};

const mainStyle: React.CSSProperties = {
  flex: 1,
  background: "#fff",
  padding: "48px 40px",
  fontFamily: "serif",
};

const layoutStyle: React.CSSProperties = {
  display: "flex",
  background: "#f3f4f6",
  minHeight: "100vh",
  width: "100%",
  margin:0
};

const headerDivStyle: React.CSSProperties = {
  borderBottom: "2px solid #303245",
  paddingBottom: "20px",
  marginBottom: "28px",
};

const nameStyle: React.CSSProperties = {
  fontSize: "34px",
  fontWeight: "bold",
  color: "#303245",
  marginBottom: "10px",
};

const mainTitleStyle: React.CSSProperties = {
  fontSize: "21px",
  color: "#2563eb",
  fontWeight: "600",
  marginBottom: "5px",
};

const summaryStyle: React.CSSProperties = {
  color: "#353535",
  fontSize: "16px",
  marginTop: "6px",
  marginBottom: "18px",
  maxWidth: "600px",
};

const contactStyle: React.CSSProperties = {
  marginBottom: "24px",
};

const contactItemStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  wordBreak: "break-all",
  marginBottom: "9px",
  fontSize: "16px",
};

const sectionTitleStyle: React.CSSProperties = {
  textTransform: "uppercase",
  fontWeight: "bold",
  fontSize: "17px",
  marginBottom: "12px",
  letterSpacing: "1px",
};

const skillContainerStyle: React.CSSProperties = {
  display: "flex",
  flexWrap: "wrap",
  gap: "7px",
};

const skillItemStyle: React.CSSProperties = {
  background: "#3e5066",
  borderRadius: "6px",
  padding: "6px 14px",
  fontSize: "15px",
  marginBottom: "4px",
  whiteSpace: "nowrap",
};

const hobbyContainerStyle: React.CSSProperties = {
  display: "flex",
  flexWrap: "wrap",
  gap: "7px",
};

const hobbyItemStyle: React.CSSProperties = {
  background: "#3e5066",
  borderRadius: "6px",
  padding: "6px 14px",
  fontSize: "15px",
  marginBottom: "4px",
  whiteSpace: "nowrap",
};

const listStyle: React.CSSProperties = {
  margin: 0,
  padding: 0,
  listStyleType: "none",
};

const languageItemStyle: React.CSSProperties = {
  fontWeight: "600",
  fontSize: "15px",
  marginBottom: "4px",
};

const subTitleStyle: React.CSSProperties = {
  fontWeight: "600",
  fontSize: "14px",
  color: "#fff",
};

const strengthDescStyle: React.CSSProperties = {
  fontSize: "13px",
  color: "#e0e0e0",
  marginTop: "2px",
};

const achievementDescStyle: React.CSSProperties = {
  fontSize: "13px",
  color: "#e0e0e0",
  marginTop: "2px",
};

const expSectionTitleStyle: React.CSSProperties = {
  fontSize: "20px",
  fontWeight: "bold",
  textTransform: "uppercase",
  color: "#303245",
  marginBottom: "18px",
};

const expDivStyle: React.CSSProperties = {
  marginBottom: "18px",
};

const expRoleStyle: React.CSSProperties = {
  fontWeight: "bold",
  fontSize: "16px",
  color: "#363636",
};

const expCompanyStyle: React.CSSProperties = {
  fontSize: "15px",
  fontWeight: "500",
  color: "#353535",
};

const expDateStyle: React.CSSProperties = {
  fontSize: "13px",
  color: "#646464",
  textAlign: "right",
};

const expSummaryStyle: React.CSSProperties = {
  fontSize: "15px",
  color: "#353535",
  marginTop: "8px",
  marginLeft: "20px",
};

const eduSectionTitleStyle: React.CSSProperties = {
  fontSize: "20px",
  fontWeight: "bold",
  textTransform: "uppercase",
  color: "#303245",
  marginBottom: "18px",
};

const eduItemStyle: React.CSSProperties = {
  marginBottom: "12px",
};

const eduDegreeStyle: React.CSSProperties = {
  fontWeight: "600",
  fontSize: "15px",
  color: "#303245",
};

const eduInstitutionStyle: React.CSSProperties = {
  fontSize: "13px",
  color: "#646464",
  fontStyle: "italic",
};

const eduDateStyle: React.CSSProperties = {
  fontSize: "13px",
  color: "#646464",
};

interface ProfessionalProps {
  data: ResumeData;
}

const Professional: React.FC<ProfessionalProps> = ({ data }) => {
  const basics = data.basics;
  const experience = data.experience || [];
  const education = data.education || [];
  const skills = data.skills || [];
  const languages: Language[] = basics.languages || [];

  return (
    <div style={layoutStyle}>
      {/* Sidebar */}
      <aside style={sidebarStyle} className="sidebar">
        {/* Contact */}
        <div style={contactStyle}>
          {basics.email && (
            <div style={contactItemStyle}>
              <MdOutlineMailOutline style={{ fontSize: "18px" }} />
              {basics.email}
            </div>
          )}
          {basics.phone && (
            <div style={contactItemStyle}>
              <MdPhone style={{ fontSize: "18px" }} />
              {basics.phone}
            </div>
          )}
          {basics.location && (
            <div style={contactItemStyle}>
              <MdOutlineLocationOn style={{ fontSize: "18px" }} />
              {basics.location}
            </div>
          )}
          {basics.social &&
            basics.social.map((link) => {
              const icon = link.label.toLowerCase().includes("linkedin")
                ? <FaLinkedin style={{ fontSize: "18px" }} />
                : <MdLink style={{ fontSize: "18px" }} />;
              return (
                <div key={link.label} style={contactItemStyle}>
                  {icon}
                  {link.url}
                </div>
              );
            })}
        </div>
        {/* Skills */}
        {skills.length > 0 && (
          <div>
            <h2 style={sectionTitleStyle}>Skills</h2>
            <div style={skillContainerStyle}>
              {skills.map((skill) => (
                <span key={skill} style={skillItemStyle}>
                  {skill}
                </span>
              ))}
            </div>
          </div>
        )}
        {/* Languages */}
        {languages.length > 0 && (
          <div>
            <h2 style={sectionTitleStyle}>Languages</h2>
            <ul style={listStyle}>
              {languages.map((lang, idx) => (
                <li key={idx} style={languageItemStyle}>
                  {getLanguageName(lang)}
                </li>
              ))}
            </ul>
          </div>
        )}
        {/* Strengths */}
        {basics.strengths && basics.strengths.length > 0 && (
          <div>
            <h2 style={sectionTitleStyle}>Strengths</h2>
            <div>
              {basics.strengths.map((strength, idx) => (
                <div key={idx}>
                  <span style={subTitleStyle}>{strength.title}</span>
                  {strength.description && (
                    <p style={strengthDescStyle}>{strength.description}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        {/* Achievements */}
        {basics.achievements && basics.achievements.length > 0 && (
          <div>
            <h2 style={sectionTitleStyle}>Key Achievements</h2>
            <div>
              {basics.achievements.map((achievement, idx) => (
                <div key={idx}>
                  <span style={subTitleStyle}>{achievement.title}</span>
                  {achievement.description && (
                    <p style={achievementDescStyle}>{achievement.description}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        {/* Hobbies */}
        {basics.hobbies && basics.hobbies.length > 0 && (
          <div>
            <h2 style={sectionTitleStyle}>Hobbies & Interests</h2>
            <div style={hobbyContainerStyle}>
              {basics.hobbies.map((hobby, idx) => (
                <span key={idx} style={hobbyItemStyle}>
                  {hobby}
                </span>
              ))}
            </div>
          </div>
        )}
      </aside>
      {/* Main Content */}
      <main style={mainStyle}>
        {/* Header */}
        <div style={headerDivStyle}>
          <h1 style={nameStyle}>{basics.name}</h1>
          {basics.title && (
            <h2 style={mainTitleStyle}>{basics.title}</h2>
          )}
          {basics.summary && (
            <p style={summaryStyle}>{basics.summary}</p>
          )}
        </div>
        {/* Experience */}
        <section>
          <h2 style={expSectionTitleStyle}>Experience</h2>
          {experience.map((exp, idx) => (
            <div key={idx} style={expDivStyle}>
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline"
              }}>
                <div>
                  <span style={expRoleStyle}>{exp.role}</span>
                  <span style={{ ...expCompanyStyle, display: "block" }}>{exp.company}</span>
                </div>
                <div>
                  <span style={expDateStyle}>
                    {exp.startDate} - {exp.current ? "Present" : exp.endDate}
                  </span>
                </div>
              </div>
              {exp.summary && (
                <ul style={{ marginLeft: "16px" }}>
                  <li style={expSummaryStyle}>{exp.summary}</li>
                </ul>
              )}
            </div>
          ))}
        </section>
        {/* Education */}
        <section>
          <h2 style={eduSectionTitleStyle}>Education</h2>
          <ul>
            {education.map((edu, idx) => (
              <li key={idx} style={eduItemStyle}>
                <span style={eduDegreeStyle}>{edu.degree}</span>
                <span style={{ ...eduInstitutionStyle, display: "block" }}>{edu.institution}</span>
                <span style={{ ...eduDateStyle, display: "block" }}>{edu.startDate} - {edu.endDate}</span>
              </li>
            ))}
          </ul>
        </section>
      </main>
      <style jsx>{`
       @media print {
  @page {
    margin: 0;
  }
  html, body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
  }
  
   html, body, #__next, .print-content {
    width: 210mm !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }
@page {
  margin: 0;
  size: auto;
}
      }

      `}</style>
    </div>
  );
};

export default Professional;
